module.exports = __webpack_public_path__ + "img/logo.509f1dff.png";